<template>
  <div class="base-content">
    <el-form label-postion="left" label-width="200px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('screen.brand')" prop="model_type">
            <el-radio-group v-model="baseInfo.model_type">
              <el-radio :label="0">{{$t('screen.brand1')}}</el-radio>
              <el-radio :label="1">{{$t('screen.brand2')}}</el-radio>
              <el-radio :label="2">{{$t('screen.brand3')}}</el-radio>
              <el-radio :label="4">{{$t('screen.brand4')}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="$t('device.device_version')" prop="screen_version">
            <el-radio-group v-model="baseInfo.screen_version">
              <el-radio :label="0">{{$t('screen.versionType')[0]}}</el-radio>
              <el-radio :label="1">{{$t('screen.versionType')[1]}}</el-radio>
            </el-radio-group>
          </el-form-item>
          
        </el-col>
        <el-col :span="24" v-if="baseInfo.screen_version&&baseInfo.model_type==2">
          <el-form-item :label="$t('screen.screen_token')" prop="screen_token">
            <el-input v-model="baseInfo.screen_token"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('screen.information_account')" prop="information_account">
            <el-input v-model="baseInfo.information_account"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('screen.information_password')" prop="information_password">
            <el-input v-model="baseInfo.information_password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('screen.app_key')" prop="app_key">
            <el-input v-model="baseInfo.app_key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('screen.app_secret')" prop="app_secret">
            <el-input v-model="baseInfo.app_secret"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('screen.imou_key')" prop="imou_key">
            <el-input v-model="baseInfo.imou_key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('screen.imou_secret')" prop="imou_secret">
            <el-input v-model="baseInfo.imou_secret"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('screen.qiniu_key')" prop="qiniu_key">
            <el-input v-model="baseInfo.qiniu_key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('screen.qiniu_secret')" prop="qiniu_secret">
            <el-input v-model="baseInfo.qiniu_secret"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('screen.charging_type')" prop="charging_type">
            <el-input v-model="baseInfo.charging_type"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('screen.charging_account')" prop="charging_account">
            <el-input v-model="baseInfo.charging_account"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('screen.charging_password')" prop="charging_password">
            <el-input v-model="baseInfo.charging_password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('screen.api_key')" prop="api_key">
            <el-input v-model="baseInfo.api_key"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('screen.broadcast')" prop="broadcast">
            <el-input v-model="baseInfo.broadcast"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog_footer">
      <el-button @click="cancel">{{$t('control.cancel')}}</el-button>
      <el-button type="primary" @click.prevent="saveInfoData">{{$t('control.submit')}}</el-button>
    </div>
  </div>
</template>
<script>
import adminsApi from "@/api/system/admin";
export default {
  name: "BaseSet",
  props: {
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      baseInfo: {
        model_type: '',
        screen_version: '',
        screen_token: '',
        information_account: '',
        information_password: '',
        app_key: '',
        app_secret: '',
        imou_key: '',
        imou_secret: '',
        qiniu_key: '',
        qiniu_secret: '',
        charging_type: '',
        charging_account: '',
        charging_password: '',
        api_key: '',
        broadcast: ''
      }
    };
  },
  methods: {
    getInfoData() {
      adminsApi.userConfig(this.userId).then((res) => {
        if (res.data.code === 1000) {
          this.baseInfo = res.data.data;
        }
      });
    },
    saveInfoData() {
      adminsApi.userConfigEdit(this.userId, this.baseInfo).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.$emit('closeMethod')
        }
      });
    },
    cancel() {
      this.$emit("closeMethod");
    }
  },
  mounted() {
    this.getInfoData();
  },
};
</script>
<style lang='less'>
.base-content{
  width:100%;
  position: relative;
  .el-row{
    border-bottom: 1px solid #eee;
    margin-bottom:35px;
    padding-bottom: 15px;
  }
}
</style>